import { motion } from "motion/react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Banner from "../components/service/Banner";
import Header from "../layouts/Header";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "../components/sectionHeader";
import SectionSubHeader from "../components/sectionSubHeader";
import Features from "../components/service/Features";
import JoinOurTeam from "../components/Home/JoinOurTeam";
import Footer from "../layouts/Footer";
const GccSetup = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const approach = [
    {
      image: "/images/target.svg",
      main: "Market research & talent pool ",
      sub: " analysis",
    },
    {
      image: "/images/finance.svg",
      main: "Location advisory & ",
      sub: "operational guidance",
    },
    {
      image: "/images/dashboard.svg",
      main: "Recruitment strategy & ",
      sub: " execution (permanent, contract, pods) ",
    },
    {
      image: "/images/Prioritizing.svg",
      main: "Regulatory and ",
      sub: "  compliance support",
    },
    {
      image: "/images/Safeguarding.svg",
      main: "Ongoing HR advisory & ",
      sub: "scaling support",
    },
    {
      image: "/images/smart.svg",
      main: "Build your India presence with confidence ",
      sub: "Volto Consulting makes it seamless.",
    },
  ];

  const featureData = {
    service_name: "OUR  SERVICE HIGHLIGHTS",
    title: "GCC Setup",
    list: [
      {
        icon: "/images/gcc-1.svg",
        title: "Launch your Global Capability Center in India ",
        content:
          " from market entry strategy and site selection to regulatory compliance and operational rollout. Executive Search",
      },
      {
        icon: "/images/gcc-2.svg",
        title:
          "Attract and secure top leadership with our bespoke search process",
        content:
          "identifying, assessing, and onboarding executive talent aligned with your vision. Contractual Services",
      },
      {
        icon: "/images/gcc-3.svg",
        title: "Flexible workforce solutions ",
        content:
          " from contract hiring and project pods to Statement of Work (SOW)-based models — ensuring scale, speed, and agility.",
      },
    ],
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-homepage service  light-theme">
        <Header />
        <div className="GCC-banner text-left">
 <Banner
          mode="dark"
          bannerImg="/images/nearshore-banner.webp"
          title="GCC Setup in India "
          main_content="At Volto Consulting, we enable global organizations to establish and scale their Global Capability Centers (GCCs) in India with speed, efficiency, and strategic precision."
        />

        </div>
       
        <div className="service-info volto-section page-type-secvies">
          <Container className="">
            <SectionHeader mainText1={"GCC Setup"} />
            <Row>
              <Col lg={6}>
                <SectionSubHeader
                  headerText={
                    "Your trusted partner for building high-performing Global Capability Centers in India."
                  }
                />
              </Col>
              <Col lg={6} className="text-justify">
                <p>
                  {
                    "From identifying the right location and talent market to designing the hiring framework and ensuring compliance with local employment regulations, we offer end-to-end support for successful GCC launches. Our deep understanding of the Indian talent ecosystem, especially in niche and high-demand skill areas, makes us a preferred partner for companies expanding their global footprint."
                  }
                </p>
                <p>
                  {
                    "Whether you're setting up a technology hub, a shared services center, or a specialized COE, Volto Consulting brings the expertise, network, and on-ground execution needed to build future-ready teams."
                  }
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="volto-section">
          <Row>
            <Col lg={5}>
              <img
                className="img-fluid h-100 mt-lg-4 "
                src="/images/gcc-service.svg"
                alt="manufacturing-approch"
              />
            </Col>
            <Col lg={7}>
              <div className="industry-approach">
                <SectionHeader
                  mainText1={"Our"}
                  mainText2={"GCC Setup Services Include"}
                />
                <SectionSubHeader
                  headerText={
                    "End-to-end support to launch and grow your GCC in India."
                  }
                />
                <p className="industry-subtext mt-4">
                  We combine strategy, compliance, and talent expertise to
                  ensure long-term success.
                </p>

                <Row className="approach-section">
                  {approach &&
                    approach.map((item, index) => {
                      return (
                        <Col lg={6} md={6} key={index} className="mb-4">
                          <img src={item?.image} alt={`approach-` + index} />
                          <h3>
                            {item?.main} <span>{item?.sub}</span>
                          </h3>
                        </Col>
                      );
                    })}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>

        <Features data={featureData} />
      </div>

      <JoinOurTeam image={"/images/join-our-team.webp"} />
      <Footer />
    </motion.div>
  );
};

export default GccSetup;
